import {
  IconCalculator,
  IconChart,
  IconFulfillment,
  IconHome,
  IconInventory,
  IconInvoice,
  IconOrders,
  IconProcurement,
  IconProducts,
  IconReport,
  IconSearch,
  IconUpload,
  IconUnshipped,
  IconUser,
} from '../../components/icons';

export const adminNavItems = [
  { id: 'home', label: 'Home', to: '/admin/dashboard', icon: IconHome },
  { id: 'search', label: 'Search', to: '/admin/search', icon: IconSearch },
  { id: 'products', label: 'Products', to: '/admin/products', icon: IconProducts },
  {
    id: 'upload-tracking',
    label: 'Upload Tracking ID',
    to: '/admin/upload-tracking',
    icon: IconUpload,
  },
  {
    id: 'revenue-calculator',
    label: 'FBM Calculator',
    to: '/admin/revenue-calculator',
    icon: IconCalculator,
  },
  { id: 'analytics', label: 'Analytics', to: '/admin/analytics', icon: IconChart },
  { id: 'orders', label: 'Orders', to: '/admin/orders', icon: IconOrders },
  {
    id: 'unshipped',
    label: 'Unshipped',
    to: '/admin/unshipped-orders',
    icon: IconUnshipped,
  },
  {
    id: 'procurement',
    label: 'Procurement',
    to: '/admin/procurement',
    icon: IconProcurement,
  },
  {
    id: 'fulfillment',
    label: 'Fulfillment',
    to: '/admin/fulfillment',
    icon: IconFulfillment,
  },
  {
    id: 'customer-service',
    label: 'Customer Service',
    to: '/admin/customer-service',
    icon: IconUser,
  },
  { id: 'inventory', label: 'Inventory', to: '/admin/inventory', icon: IconInventory },
  { id: 'invoices', label: 'Invoices', to: '/admin/invoices', icon: IconInvoice },
  { id: 'reports', label: 'Reports', to: '/admin/reports', icon: IconReport },
];

export function getAdminNavMeta(pathname) {
  const match = adminNavItems.find(
    (item) => pathname === item.to || pathname.startsWith(`${item.to}/`)
  );

  if (match) {
    return match;
  }

  return adminNavItems[0];
}
